import format from 'date-fns/format';
import isValid from 'date-fns/isValid';
import parseISO from 'date-fns/parseISO';

export const formatTerminalDate = (value?: string | null) => {
  if (!value) return '—';

  const date = parseISO(value);
  return isValid(date) ? format(date, 'dd/MM/yyyy HH:mm') : '—';
};
